var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._b({attrs:{"disabled":!!_vm.t || _vm.disabled},on:{"click":_vm.handleClick}},'el-button',_vm.$attrs,false),[(!!_vm.t)?[_vm._v(" "+_vm._s(_vm.time)+"s内不可操作 ")]:[_vm._t("default",function(){return [_vm._v("更新")]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }